<!-- Top pane -->

<div class="bg-col-5 p-t-3 p-b-3 listing-filters"
     id="product-listing-sticky-filters"
     sticky
     [stickyTop]="0"
     [stickyOffsetSectionId]="headerId"
     [stickyDetectDirection]="true"
     [stickyOff]="client.isS || client.isM">
    <div class="wrap">
        <div class="c-3 c-6-m c-12-s m-b-0 va-m">
            <label class="flex flex-middle p2 p-a-0 b-b b-col-43">
                <i class="m-r pos-relative"
                   [toggleClass]="'icon-loading !icon-search'"
                   [toggleClassBy]="searchBusy$"
                   aria-hidden="true"
                   [style.font-size.px]="16"></i>

                <input [sizeClass]="'S: p2, !S: p1'"
                       type="text"
                       [attr.placeholder]="'Search by product name or SKU' | translate"
                       [(ngModel)]="searchTerm"
                       (keyup)="onSearchKeyUp($event)">
                @if(overrideContext === 'search') {
                <i class="pos-relative icon-close cursor-pointer m-l"
                   [style.font-size.px]="16"
                   (click)="resetSearch()"
                   aria-hidden="true"></i>
                }
            </label>
        </div>
        <ng-container *ifSize="'!SM'">
            <div class="c-2 m-b-0"></div>
            <span class="col-11 c-2 c-2-m inline-flex flex-wrap flex-justify-center-l m-b-0 m-r-0 m-l-2 va-m p1">
                <span>{{'Quantity' | translate}}:</span>&nbsp;<span class="col-1"
                      style="word-break:break-all">{{bulk.getTotalQty()}}</span>
            </span>
            <span class="col-11 c-2 inline-flex flex-wrap flex-justify-center-l m-r-16-m m-b-0 va-m p1">
                <span class="col-11">{{'Total' | translate}}:</span>&nbsp;
                <price [value]="bulk.getTotalPrice()"
                       class="col-1"
                       style="word-break:break-all"></price>
            </span>
            <div class="c-1 m-b-1 m-r-8-m va-m">
                <button class="button p-l p-r"
                        sizeClass="!M: no-wrap"
                        (click)="bulk.reset()"
                        [disabled]="!bulk.getTotalQty()">
                    <span class="button__body">{{'Clear all' | translate}}</span>
                </button>
            </div>
            <div class="c-2 m-b-0 m-r-0 va-m">
                <action class="button w-12 w-11-l m-l-4-l"
                        (click)="submit()"
                        [class.disabled]="!bulk.getTotalQty()"
                        [status]="submissionStatus">{{'Add to bag' | translate}}</action>
                <div class="m-t-1 right pos-relative">
                    <result [status]="submissionStatus"
                            class="pos-absolute right-0 top-0 inline"
                            [style.width.em]="50"></result>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<!-- fitlers -->
<!-- <product-listing-tools class="wrap block"
                       type="bulkOrder"
                       [listing]="listing"></product-listing-tools> -->

<!-- title row -->
@if(client.sizeId > 0) {
<div class="b-b b-t b-col-4 p-t-4 p-b-4">
    <div class="wrap p1 col-11 ">
        <div class="c-4 m-b-0 va-m">{{'Product' | translate}}</div>
        <div class="c-2 m-b-0 va-m">{{'Product code' | translate}}</div>
        <div class="c-3 c-2-m m-b-0 va-m">{{'Quantity' | translate}}</div>
        <div class="c-2 c-2-x c-2-l m-b-0 va-m">{{'Unit price' | translate}}</div>
        <div class="c-1 right m-r-0 m-b-0 va-m">{{'Total' | translate}}</div>
    </div>
</div>
}

<!-- note -->
@if(listWarning) {
<div class="center">
    <p class="p-a m-t m-b b-a bg-col-52 h4 inline-block">
        {{listWarning}}
        @if(overrideContext) {
        <button class="underline"
                aria-label="Show all"
                (click)="restoreModels()">{{'Click here' | translate}}</button> {{'to exit' | translate}}.
        }
    </p>
</div>
}

<!-- listing -->
<div class="m-t m-t-0-s overflow-hidden wrap"
     (infiniteScroll)="loader.loadMore()"
     [infinitScrollActive]="canLoadMore">
    @for(product of models; track product.id) {
    <bulk-order-listing-product [product]="product"
                                [bulk]="bulk"
                                class="block p-t-5 p-b-5 p-t-2-s p-b-2-s b-b col-4">

    </bulk-order-listing-product>
    }
</div>
@if(canShowLoader) {
<skeleton-loader [numberOfLines]="5"
                 [height]="'100px'"></skeleton-loader>
}

<!-- mobile add to basket -->
@if(client.sizeId < 2)
  {
  <div
  class="pos-fixed left-0 bottom-0 bg-col-w p-a p-t-5 z-3 b-t b-col-1 w-12">
    <div class="p2 inline-flex flex-justify-between w-12">
        <span class="c-6-set flex flex-wrap">
            <span class="col-11">{{'Quantity' | translate}}:</span>&nbsp;<span class="col-1"
                  style="word-break:break-all">{{bulk.getTotalQty()}}</span>
        </span>

        <span class="c-6-set flex flex-wrap m-r-0">
            <span class="col-11">{{'Total' | translate}}:</span>&nbsp;
            <price [value]="bulk.getTotalPrice()"
                   class="col-1"
                   style="word-break:break-all"></price>
        </span>
    </div>
    @if(bulk.getTotalQty()) {
    <div class="flex m-t-3">
        <button class="button c-4 m-b-0 p-l p-r"
                sizeClass="!M: no-wrap"
                (click)="bulk.reset()">
            <span class="button__body">{{'Clear all' | translate}}</span>
        </button>

        <action class="button c-8 m-b-0 m-r-0"
                (click)="submit()"
                [status]="submissionStatus">
            <span>{{'Add to bag' | translate}}</span>
        </action>
        <div class="m-t-1 right pos-relative">
            <result [status]="submissionStatus"
                    class="pos-absolute right-0 bottom-100 m-b-2 inline"
                    [style.width.em]="50"></result>
        </div>
    </div>
    }
    </div>
    }